import { Link } from "react-router-dom";
import SEO from "../components/common/SEO";

/**
 * 404 page for unknown routes.
 *
 * Replaces the old catch-all that silently redirected every unknown URL to the
 * homepage — that pattern produced "soft 404s" (Google saw a 200 + homepage
 * content for URLs that don't exist). This page is explicitly noindexed and
 * offers useful next steps instead of a dead end.
 *
 * Direct requests to unknown public URLs receive the static HTTP 404 page.
 * This component handles unknown routes reached through client navigation.
 */
const NotFound = () => {
  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "48px 20px",
        gap: "12px",
      }}
    >
      <SEO
        title="Page Not Found"
        description="Sorry, we couldn't find that page. Get a free home-improvement estimate or head back to the homepage."
        noindex
      />
      <p
        style={{
          fontFamily: "monospace",
          letterSpacing: "0.1em",
          color: "#9CA3AF",
          margin: 0,
        }}
      >
        404
      </p>
      <h1 style={{ fontSize: "1.75rem", margin: "4px 0 0", color: "#1F2937" }}>
        We couldn't find that page
      </h1>
      <p style={{ maxWidth: "42ch", color: "#4B5563", margin: "4px 0 16px" }}>
        The page you're looking for may have moved or never existed. Try one of
        these instead:
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "center" }}>
        <Link
          to="/chat"
          style={{
            background: "#F59E0B",
            color: "#1F2937",
            fontWeight: 600,
            padding: "12px 20px",
            borderRadius: "8px",
            textDecoration: "none",
          }}
        >
          Get a free estimate
        </Link>
        <Link
          to="/"
          style={{
            border: "1px solid #D1D5DB",
            color: "#1F2937",
            fontWeight: 600,
            padding: "12px 20px",
            borderRadius: "8px",
            textDecoration: "none",
          }}
        >
          Back to homepage
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
